export const DISPLAY_MESSAGE_REQUEST = "DISPLAY_MESSAGE_REQUEST";
export const DISPLAY_ERROR_REQUEST = "DISPLAY_ERROR_REQUEST";
export const CLEAR_ALERTS = "CLEAR_ALERTS";
export const HIDE_MESSAGE_REQUEST = "HIDE_MESSAGE_REQUEST";
export const MESSAGE_REQUEST_FAIL = "MESSAGE_REQUEST_FAIL";
